import { Form, InputNumber, Switch } from "antd";
import './index.less';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TimeInterval } from "../../type";

interface InputNumberAddonProps {
  symbol: string;
  [key: string]: any;
}

function InputNumberAddon({ symbol, ...restProps }: InputNumberAddonProps) {
  return (
    <div className="input-number-addon-box">
      <InputNumber className="mini-input-number" {...restProps} controls={false} />
      <div className="addon">
        {symbol}
      </div>
    </div>
  );
}

interface RandomTaskTimeProps {
  form: any;
  type: TimeInterval,
  symbol: any
}

export default function RandomTaskTime({ form, type, symbol }: RandomTaskTimeProps) {
  const { t } = useTranslation()
  const bol = form.getFieldValue('openRandomTaskTime');
  const [isRandom, setIsRandom] = useState<boolean>(bol ? bol : false);

  function toggle(val: boolean) {
    setIsRandom(val);
  }

  return (
    <div className="random-task-time-box">
      {
        type !== TimeInterval.RandomInterval &&  <div className="form-items-head">
          <h3>{ t("manyToMany.executionIntervalSeconds") }</h3>
        </div>
      }
     
      {
        type === TimeInterval.RandomInterval && <div className="form-items">
          <div className="col col-218">
            <h3>{ t("manyToMany.minSeconds") }</h3>
            <Form.Item
              name="randomTaskTimeStart"
              label={null}
              rules={[
                { type: 'number', min: 1, max: 60 },
                {
                  validator: (_: any, value: number) => {
                    const endValue = form.getFieldValue('randomTaskTimeEnd');
                    if (value >= 1 && (!endValue || value < endValue)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(t("multiSwap.mustBeLessThanEndTimeAndMinimumOf1"));
                  }
                }
              ]}
            >

              <InputNumberAddon symbol={symbol} min={1} max={60} precision={2} controls={false} />
            </Form.Item>
          </div>
          <span className="span-12">~</span>
          <div className="col col-218">
            <h3>{ t("manyToMany.maxSeconds") }</h3>
            <Form.Item
              name="randomTaskTimeEnd"
              label={null}
              rules={[
                { type: 'number', min: 2, max: 60 },
                {
                  validator: (_: any, value: number) => {
                    const startValue = form.getFieldValue('randomTaskTimeStart');
                    if (!startValue || value > startValue) {
                      return Promise.resolve();
                    }
                    return Promise.reject(t("multiSwap.endTimeMustBeGreaterThanStartTime"));
                  }
                }
              ]}
            >
              <InputNumberAddon symbol={symbol} min={2} max={60} precision={2} controls={false} />
            </Form.Item>
          </div>
        </div>
      }
      {
        type === TimeInterval.FixedInterval && <div className="form-items">
          <div className="col one-col">
            <Form.Item
              name="fixedTaskTime"
              label={null}
              rules={[
                { required: true, message:  t("manyToMany.pleaseEnterIntervalTime") },
                { type: 'number', min: 1, max: 60,  message: t("multiSwap.minimumOf1") }
              ]}
            >
              <InputNumberAddon symbol={symbol} min={1} max={60} precision={2} controls={false} />
            </Form.Item>
          </div>
        </div>
      }
       {
        type === TimeInterval.NoInterval && <div className="form-items">
          <div className="col one-col">
            <Form.Item
              name="noInterval"
              label={null}
            >
              <InputNumberAddon symbol={symbol} min={1} max={60} precision={2} controls={false} placeholder={ t("manyToMany.noInterval") }  disabled/>
            </Form.Item>
          </div>
        </div>
      }
    </div>
  );
}
